<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedContrato" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-selected-data="customUpdateSelectedData"
                    :custom-update-collection-data="customUpdateCollectionData"
                    @updateValues="setupUpdateValues" :updatePermission="'update_contratos'"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedContrato"
                           :load-data="loadDataContrato"
                           :entity="entity" :auth-token="authToken" :list-api="listApi" :queries="queries"
                           :custom-update-load-data="customUpdateLoadData"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataContrato" :selected-data="selectedContrato"
                 :view="view" :custom-update-value-data="customUpdateValueData" :authToken="authToken"
                 @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import ContratosCrearActualizarComponent from "@/components/parametros/components/ContratosCrearActualizarComponent";
import { useLayoutMain} from "@/layouts/main";
import {copiaProfunda} from "@/common/constants";

export default {
  name: 'ContratosCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    ContratosCrearActualizarComponent,
  },
  data: function () {
    return {
      Object: Object,
      title: 'Contratos',
      entity: {gender: 'm', value: 'contrato'},
      childFormComponent: 'contratosCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'codigo': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Código del contrato'
        },
        'concepto': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Concepto'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedContrato = ref({
      id: '',
      codigo: '',
      concepto: '',
      valor:'',
      estado: ''
    });
    const loadDataContrato = ref({
      codigo: '',
      concepto: '',
      valor:''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_CONTRATO_CREATE,
      list: process.env.VUE_APP_NEST_CONTRATO_FINDALL,
      update: process.env.VUE_APP_NEST_CONTRATO_UPDATE,
      updateState: process.env.VUE_APP_NEST_CONTRATO_UPDATESTATE
    });
    const customUpdateValueData = (key, value) => {
      if (key === 'codigo') return Number(value);
      return value;
    };
    const customUpdateSelectedData = (selectedCollectionData) => {
      const updatedSelectedData = {};
      for (const key of Object.keys(selectedContrato.value)) {
        updatedSelectedData[key] = customUpdateValueData(key, selectedCollectionData[key]);
      }
      selectedContrato.value = updatedSelectedData;
    }
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionData.value);
      return copyCollectionData;
    };
    const customUpdateLoadData = () => {
      for (const key in loadDataContrato.value) {
        let value = loadDataContrato.value[key];
        value = customUpdateValueData(key, value);
      }
    };
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedContrato, loadDataContrato, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedContrato,
      loadDataContrato,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      customUpdateSelectedData,
      customUpdateCollectionData,
      customUpdateLoadData,
      customUpdateValueData
    };
  }
}
</script>